module.exports = __webpack_public_path__ + "img/ar.0751c6ff.svg";